import React, { Component } from 'react';
import { isStartsWithNumber } from '../../common/globals';

class CopyDers extends Component {
  render() {
    const { derNo } = this.props;
    const derNoFlag = isStartsWithNumber(derNo);
    return (
      <div
        className="modal fade theme-modal" id="copyDersModal"
        tabIndex="-1" aria-labelledby="copyDersModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p>You have created a copy of DER# {`${!derNoFlag ? '' : derNo}`}</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-12">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal">OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CopyDers;
